<div
  class="relative flex items-center justify-between px-8 py-7 shadow-[0px_4px_12px_4px_rgba(0,0,0,0.05)] lg:px-16 xl:px-24"
>
  <a
    routerLink="/"
    class="relative flex shrink-0 items-center gap-4 hover:text-black"
  >
    <img
      class="h-[30px] w-[96px] cursor-pointer xl:h-[47px] xl:w-[147px]"
      ngSrc="assets/images/logo.svg"
      alt="OEW CORE:Address"
      height="47"
      width="147"
      priority="priority"
    />
    <span class="font-bold xl:text-xl">CORE:Address</span>

    @if (!environment.production) {
      <span
        data-test-id="environmentIdentifier"
        class="absolute right-0 -bottom-4 bg-linear-to-r from-blue-500 via-green-500 to-orange-500 bg-clip-text font-mono font-bold text-transparent"
      >
        {{ environment.identifier }}
      </span>
    }
  </a>

  <input
    type="checkbox"
    id="mobile-menu-toggle"
    class="peer hidden"
    [(ngModel)]="isOpen"
  />
  <app-button
    data-test-id="menuToggleButton"
    class="-m-4 md:hidden"
    size="large"
    shape="circle"
    type="transparent"
    (trigger)="toggleMenu()"
  >
    <svg-icon
      src="assets/icons/General/menu-01.svg"
      class="inline-block size-6"
    />
  </app-button>

  <!-- Backdrop to close menu when clicking outside -->
  <label
    for="mobile-menu-toggle"
    class="invisible fixed inset-0 z-40 bg-black/20 opacity-0 transition-all peer-checked:visible peer-checked:opacity-100 md:hidden"
  ></label>

  <div
    class="fixed inset-y-0 right-0 z-50 hidden w-60 bg-white shadow-[0px_4px_12px_4px_rgba(0,0,0,0.05)] peer-checked:block md:relative md:block md:w-auto md:shadow-none"
  >
    <div class="flex justify-end p-4 md:hidden">
      <app-button
        data-test-id="closeMenuButton"
        class="inline-block"
        type="transparent"
        size="large"
        shape="circle"
        (trigger)="closeMenu()"
      >
        <svg-icon
          src="assets/icons/General/x-close.svg"
          class="inline-block size-6"
        />
      </app-button>
    </div>

    <div
      class="flex flex-col gap-x-4 gap-y-6 p-4 md:w-auto md:flex-row md:py-0 xl:gap-x-10"
    >
      @if (user?.hasSnapshotAccess) {
        <ng-container
          [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{
            link: 'addresses',
            label: 'pages.addressMaster.title' | translate,
            icon: 'Maps_travel/marker-pin-01.svg',
          }"
        />
      }
      @if (user?.hasSnapshotAccess) {
        <ng-container
          [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{
            link: 'snapshots',
            label: 'pages.snapshots.title' | translate,
            icon: 'Images/camera-03.svg',
          }"
        />
      }
      @if (user?.hasAssetAccess) {
        <ng-container
          [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{
            link: 'uploads',
            label: 'pages.uploads.title' | translate,
            icon: 'General/upload-01.svg',
          }"
        />
      }
      @if (user?.hasAuditAccess) {
        <ng-container
          [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{
            link: 'clearings',
            label: 'pages.clearings.title' | translate,
            icon: 'General/check-verified-01.svg',
          }"
        />
      }

      <hr class="border-1 border-grey-300 md:hidden" />
      <div class="group relative flex flex-col gap-4">
        <span
          data-test-id="userButton"
          class="flex shrink-0 cursor-pointer items-center gap-2 text-grey-600 no-underline"
        >
          <svg-icon class="size-5" src="assets/icons/Users/user-01.svg" />
          {{ user?.name }}
          <svg-icon
            class="hidden size-5 md:block"
            src="assets/icons/Arrows/chevron-down.svg"
          />
        </span>

        <div
          class="top-12 right-0 z-10 min-w-10 bg-white [transition:opacity_0.5s,visibility_0.5s_linear] group-hover:visible group-hover:opacity-100 md:invisible md:absolute md:p-4 md:opacity-0 md:shadow-sm"
        >
          <app-button
            data-test-id="logoutButton"
            type="outline"
            (trigger)="logout()"
          >
            <svg-icon
              class="size-4"
              src="/assets/icons/General/log-out-01.svg"
            />
            <span class="text-sm">Logout</span>
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #menuItem let-link="link" let-label="label" let-icon="icon">
  <a
    class="flex items-center gap-1 hover:text-blue hover:underline hover:decoration-2 hover:underline-offset-8"
    routerLinkActive="text-blue underline underline-offset-8 decoration-2 "
    [attr.data-test-id]="`menuItem-${link}`"
    [routerLink]="link"
    [title]="label"
    (click)="closeMenu()"
  >
    <svg-icon class="size-5" [src]="`assets/icons/${icon}`" />
    <span class="md:hidden lg:block">{{ label }}</span>
  </a>
</ng-template>
